import React from 'react';
import createClass from 'create-react-class';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import {Form, InputWrapper, Input, Button} from 'ui-library';
import i18n from 'i18n';

import AppActions from 'modules/legacy/js/actions/app';
import AuthActions from 'modules/legacy/js/actions/auth';
import emailRegex from 'modules/legacy/js/mixins/emailRegex';
import recaptcha from 'modules/legacy/js/mixins/recaptcha';
import API from 'modules/legacy/js/lib/api';
import {LoginSupportLinks as SupportLinks} from 'modules/shared/containers';
import {PartnerFormRoute} from 'apps/advertisers/PartnerForm';

import { loginCoverImg, logoImgObs } from 'assets/images';

function mapStateToProps({app}) {
  return {
    currentLanguage: app.currentLanguage,
    partnerSettings: app.partnerSettings
  };
}

const ForgottenPassword = createClass({
  displayName: 'forgotView',

  propTypes: {
    currentLanguage: PropTypes.string.isRequired
  },

  mixins: [
    emailRegex,
    recaptcha,
    Reflux.listenTo(AuthActions.registerError, 'onRegisterError'),
    Reflux.listenTo(AppActions.reCAPTCHALoaded, 'updateReCaptchaWidget')
  ],

  getInitialState() {
    return {
      email: '',
      doneRequest: false,
      errorMessage: ''
    };
  },

  onRegisterError(res) {
    AppActions.displayAlert({
      type: 'error',
      message: res.message
    });

    this.updateReCaptchaWidget();
  },

  onSendData(event) {
    event.preventDefault();

    if (!this.validateForm()) return event.stopPropagation();

    return API.resetPassword({email: this.state.email}, (err, res) => {
      if (err || res.code) return AppActions.displayAlert({
        type: 'error',
        message: res.message
      });
      if (res.email) this.setState({doneRequest: true});

      return AppActions.displayAlert({
        type: 'success',
        message: i18n.get('FORGOT_SUCCESS_ALERT_DESCRIPTION')
      });
    });
  },

  validateForm() {
    let valid;
    let errorFocused;

    valid = true;
    errorFocused = false;
    const addErrorFn = (el) => {
      valid = false;
      el.parentNode.classList.add('error');

      if (errorFocused === false) {
        el.focus();
        errorFocused = true;
      }
    };

    if (this.emailRegex.test(this.state.email) === false) {
      addErrorFn(ReactDOM.findDOMNode(this.refs.emailInput));
      this.setState({errorMessage: i18n.get('FORGOT_INVALID_EMAIL_ERROR')});
    }

    return valid;
  },

  handleEmailInputChange(e) {
    e.target.parentNode.classList.remove('error');
    this.setState({
      email: e.target.value,
      errorMessage: ''
    });
  },

  render() {
    const forgotBody = (
      <div>
        <h4 className='vf-text-gray-dark margin-bottom-3x'>
          {i18n.get('FORGOT_WELL_SEND_YOU_INSTRUCTIONS')}
        </h4>

        <Form onSubmit={this.onSendData}>
          <div className='vf-input-group'>
            <InputWrapper ref='emailWrapper' className='lg'>
              <i className='vf-icon icon-mail'></i>
              <Input
                ref='emailInput'
                onChange={this.handleEmailInputChange}
                placeholder={i18n.get('FORGOT_EMAIL_PLACEHOLDER')}
                type='email'
                inputSize='lg'
              />
            </InputWrapper>
          </div>

          <div className='vf-text-danger margin-top-1x'>
            {this.state.errorMessage}
          </div>

          <div id='recaptcha' className='recaptcha-container' ref='recaptcha'></div>

          <div className='center-xs'>
            <Button
              color='primary'
              size='lg'
              type='submit'
              className='margin-top-2x'
            >
              {i18n.get('FORGOT_RESET_PASSWORD')}
            </Button>
          </div>
        </Form>
      </div>
    );

    const doneRequestBody = (
      <div className='login-text'>
        <h4 className='login-text-big'>
          {i18n.getHTML('FORGOT_WE_WILL_SEND_YOU_AN_EMAIL', {email: this.state.email})}

          <p className='margin-top-Hx'>{i18n.get('FORGOT_IT_WILL_TAKE_SOME_MINUTES')}</p>
        </h4>

        <div className='center-xs margin-top-1x'>
          <Button
            color='primary'
            size='lg'
            className='margin-vertical-1x'
            onClick={this.onSendData}
          >
            {i18n.get('FORGOT_SEND_AGAIN')}
          </Button>
        </div>
      </div>
    );

    if (this.props.partnerSettings) return <PartnerFormRoute />;

    return (
      <div className='vf-row no-space'>
        <div className='col-md-5 col-xs-12'>
          <div className='flex flex-row no-space start-md center-xs'>
            <div className='login'>
              <div className='background' />
              <div className='overlay' />

              <div className='form'>
                <div className='flex flex-row between-xs margin-vertical-1x'>
                  <img alt='' src={logoImgObs} className='logo' />

                  <Link
                    to='/login'
                    data-uitest='login-button'
                    className='vf-btn outline vf-btn-primary vf-btn--sm'
                    style={{padding: '1.2rem 4rem'}}
                  >
                    {i18n.get('FORGOT_LOG_IN')}
                  </Link>
                </div>

                <div className='title no-margin vf-text-gray-dark'>
                  {i18n.get('FORGOT_RESET_YOUR_PASSWORD')}
                </div>

                {this.state.doneRequest ? doneRequestBody : forgotBody}
              </div>

              <SupportLinks />
            </div>
          </div>
        </div>
        <div className='col-md-7 hide-xs cover' style={{backgroundImage: `url('${loginCoverImg}')`}}>
          <div className='gradient login' />
        </div>
      </div>
    );
  }
});

export default connect(mapStateToProps)(ForgottenPassword);
